import * as React from 'react';
import { MyNotificationsContainerProps } from 'app/area/user-profile/my-notifications/types';
import { AddSmsConsent } from 'app/area/user-profile/my-notifications/consents/add-sms-consent';
import { SimpleFormComponentProps } from 'app/infrastructure/simple-form/types';
import styles from './top-panel.scss';

interface TopPanelPropsExternal {
  recipientId: number;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  loadData: () => void;
}

export type TopPanelProps = MyNotificationsContainerProps & TopPanelPropsExternal;

export const TopPanel = (props: TopPanelProps) => {
  const { permission, formComponent: SimpleForm, loadData } = props;

  const hasPermissions = permission && Object.keys(permission).map(key => permission[key]).includes(true);

  return (hasPermissions ? <div className={`row ${styles.buttonContainer}`}>
    <div className="col-md-12">
      {permission && permission.sms
        && <AddSmsConsent
          {...props}
          formComponent={SimpleForm}
          loadConsents={loadData} />}
    </div>
  </div> : null);
};
